/**
 * 真人游戏首页
 */
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'
import RichHeader from './RichHeader.jsx';
import MainFooter from '../../components/footers/Original_Main.jsx'
import SideBar from '../../components/affix/SideBar.jsx';
import Loader from '../../components/icon/Loader.jsx';
import Entrance from '../../components/entrance/entrance.jsx';
import TransferMoney from '../../components/modal/TransferMoney.jsx';

class Casino extends React.Component {

  constructor(props) {
	  super(props);
    this.closeCreateUserModal = this.closeCreateUserModal.bind(this);
	  this.state = {
       createUserDisplay: false,
        domainName:false
	  }
  }

  componentDidMount() {
    this.setState({
      domainName:window.location.hostname.indexOf('hengy800')!==-1
    })
  }

  // 直接进入平台 
  openTransfer(platfrom){
    this.props.$$BASE.openOverlay();
    this.props.$$BASE.openTransferModal(platfrom)
  }

  // 进入游戏
  enterGame(url, platform){
    const __user = this.props.__USER.toJS();
    // wm需要先判断平台是否可用
    if (platform == 'wm') {
      window.location.href = '#/casino';
      // 还未加载完成
      if (!__user.platform_profile.wm.onload) {
        return this.props.$$BASE.openToast('平台数据加载中，请稍后...');
      }
      // 平台不可用
      if (!__user.platform_profile.wm.available) {
        this.props.$$BASE.openOverlay();
        this.setState({
          createUserDisplay: true
        })
        return;
      }
      // 平台可用
      window.open(url);
      return;
    }
    window.location.href = url;
  }

  // 隐藏创建用户
  closeCreateUserModal(){
    this.props.$$BASE.closeOverlay();
    this.setState({
      createUserDisplay: false
    })
  }

  // 创建平台用户
  createPlatformUser(platform){
    // 用户名，密码，昵称
    let username, password, nickname;
    username = ReactDOM.findDOMNode( this.refs.wname ).value
    password = ReactDOM.findDOMNode( this.refs.wpass ).value
    nickname = ReactDOM.findDOMNode( this.refs.wnickname ).value
    const reg1 = /\w{5,17}/;
    const reg2 = /\w{6,30}/;
    const reg3 = /\w/;
    if(username==""){
      this.props.$$BASE.openAlert("用户名不能为空")
      return
    }
    if(!reg1.test(username)){
      this.props.$$BASE.openAlert("用户名格式错误")
      return
    }
    if(password==""){
      this.props.$$BASE.openAlert("密码不能为空")
      return
    }
    if(!reg2.test(password)){
      this.props.$$BASE.openAlert("密码格式错误")
      return
    }
    if(nickname==""){
      this.props.$$BASE.openAlert("昵称不能为空")
      return
    }
    if(!reg3.test(nickname)){
      this.props.$$BASE.openAlert("昵称格式错误")
      return
    }
    this.props.$$USER.createPlatformAccount(platform, username, password, nickname);
    this.props.$$BASE.closeOverlay();
    this.setState({
      createUserDisplay: false
    })
  }

  render() {

    const __user = this.props.__USER.toJS();
    const {domainName} = this.state
    return (
      <div className="casino-container" key='casino'>
        <div>
          <RichHeader />
          <SideBar />
       		<div className="zryx_banner clearfix">
       			<div className="content">            
	       			<div className="zryx_enter pt-casino">
	       				<Entrance money={__user.balance.pt} gameName="PT" imgname='zrpt' transferFn={this.openTransfer.bind(this,"PT")} url="#/game/pt/casino"/>
	       			</div>
                      <div className = "zryx_enter ag-casino" style={{display:domainName?'none':''}}>
                        <Entrance money={__user.balance.ag} gameName="AG" imgname='zrag' transferFn={this.openTransfer.bind(this,"AG")} url="#/game/ag/casino"/>
                      </div>
                    <div className="zryx_enter bbin-casino">
                      <Entrance money={__user.balance.bbin} gameName="BBIN" imgname='zrbbin' transferFn={this.openTransfer.bind(this,"BBIN")} url="#/game/bbin/casino"/>
                    </div>
            </div>
       		</div> 
          <MainFooter />
        </div>
        {
          this.state.createUserDisplay ?
          <div className="wm-container">
            <div className="wm-box">
              <h2>请创建您的WM账户</h2>
              <ul>
                <li>
                  <label>用&nbsp;&nbsp;户&nbsp;&nbsp;名：</label>
                  <input className="wname" type="text" placeholder="请输入用户名" ref="wname" />
                  <span>由5-17位字符组成（不允许有特殊字符）</span>
                </li>
                <li>
                  <label>登录密码：</label>
                  <input className="wpass" type="password" placeholder="请输入密码" ref="wpass" />
                  <span>由6-30位字符组成（不允许有特殊字符）</span>
                </li>
                <li>
                  <label>昵&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
                  <input className="wnickname" type="text" placeholder="请输入昵称" ref="wnickname" />
                  <span>不允许有特殊字符</span>
                </li>
                <li>
                  <button onClick = {this.createPlatformUser.bind(this,"wm")}>确&nbsp;&nbsp;&nbsp;&nbsp;定</button>
                </li>
              </ul>
              <span className="close-btn" onClick={this.closeCreateUserModal}>X</span>
            </div>
          </div>
          :null
        }
      </div>
    ); 

  }
}

reactMixin(Casino.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __USER: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$USER: bindActionCreators(userAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Casino)